import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';

import News from 'components/NextconLabNews/News';
import { useEffect } from "react";

function Fnews() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <News/>
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <News/>
        <Footer />
      </>
    )}
    </>
  );
}

export default Fnews;
